<div class="download-request-container">
  <div class="select-row select-row-position full-column-span">
    <ag-checkbox-tree (selectionChanged)="this.onCheckBoxTreeSelectionChanged($event)"
                      [disabledTooltipText]="'No respondent data is available for this product'"
                      [searchBarLabel]="'Search for Respondents'"
                      [title]="'Product & Respondent'"></ag-checkbox-tree>
  </div>
</div>
